import React from 'react';


const DivBetween = ({ children, className = '', style = {} }) => {
  return (
    <div
      className={`d-flex justify-content-between align-items-center ${className}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default DivBetween;
